/**
 * Do not edit directly
 * Generated on Thu, 06 Aug 2026 06:14:24 GMT
 */

export const xs = "4px";
export const sm = "8px";
export const md = "16px";
export const lg = "32px";
export const xl = "64px";
